import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { reviewService } from '../../services';
import { FEED_QUERY_KEY } from './useFeed';

export const SAVED_QUERY_KEY = 'saved';

export function useSavedRestaurants(enabled = true) {
  return useQuery({
    queryKey: [SAVED_QUERY_KEY],
    queryFn: () => reviewService.getSaved(),
    enabled,
  });
}

export function useSaveReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reviewId) => reviewService.saveReview(reviewId),
    onSuccess: () => {
      queryClient.invalidateQueries([SAVED_QUERY_KEY]);
      queryClient.invalidateQueries([FEED_QUERY_KEY]);
    },
  });
}

export function useUnsaveReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reviewId) => reviewService.unsaveReview(reviewId),
    onSuccess: () => {
      queryClient.invalidateQueries([SAVED_QUERY_KEY]);
      queryClient.invalidateQueries([FEED_QUERY_KEY]);
    },
  });
}
